var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-dropdown",
        [
          _c(
            "div",
            {
              staticClass: "header-avatar",
              staticStyle: { cursor: "pointer" },
            },
            [
              _c("a-avatar", {
                staticClass: "avatar",
                attrs: {
                  size: "small",
                  shape: "circle",
                  src: _vm.user.headImg,
                },
              }),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.user.deptName) + "-" + _vm._s(_vm.user.name)),
              ]),
            ],
            1
          ),
          _c(
            "a-menu",
            {
              class: ["avatar-menu"],
              attrs: { slot: "overlay" },
              slot: "overlay",
            },
            [
              _c(
                "a-menu-item",
                {
                  on: {
                    click: function ($event) {
                      _vm.show = true
                    },
                  },
                },
                [
                  _c("a-icon", { attrs: { type: "setting" } }),
                  _c("span", [_vm._v("修改密码")]),
                ],
                1
              ),
              _c("a-menu-divider"),
              _c(
                "a-menu-item",
                { on: { click: _vm.logout } },
                [
                  _c("a-icon", {
                    staticStyle: { "margin-right": "8px" },
                    attrs: { type: "poweroff" },
                  }),
                  _c("span", [_vm._v("退出登录")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "设置新密码",
            centered: "",
            maskClosable: false,
            visible: _vm.show,
            closable: false,
            footer: null,
            width: 600,
          },
        },
        [
          _c("setPassword", {
            ref: "setPassword",
            on: {
              cancel: function ($event) {
                _vm.show = false
              },
              save: _vm.logout,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }